/**
 * Text input types.
 * These types are based on the HTML input type attribute.
 * @module textInputTypes
 * @category FormInputs
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * Text input type
 * @type {string}
 */
export const TEXT = "text";

/**
 * Email input type
 * @type {string}
 */
export const EMAIL = "email";

/**
 * Password input type
 * @type {string}
 */
export const PASSWORD = "password";

/**
 * Number input type
 * @type {string}
 */
export const NUMBER = "number";

/**
 * Telephone input type
 * @type {string}
 */
export const TEL = "tel";

/**
 * URL input type
 * @type {string}
 */
export const URL = "url";
